import { useState } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { InfoButton } from "../../buttons";
import { LegalDocumentLink } from "../../link";

import { InformationModal } from "./InformationModal";

interface Props {
  isD2C?: boolean;
}

export function PersonalDetailsDisclaimer({ isD2C }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Box
        sx={(theme) => ({
          display: "flex",
          alignItems: "center",
          gap: theme.spacing(1),
        })}>
        {isD2C ? null : <InfoButton />}
        <Typography variant="body2">
          {isD2C ? (
            <>
              <Typography
                variant="body2"
                component="span"
                fontWeight="bold"
                color="info.main">
                We don&apos;t sell your data.
              </Typography>{" "}
              By selecting Get Quote, you are confirming that you have read our
            </>
          ) : (
            "By selecting Get Quote, you are confirming that you have read our"
          )}{" "}
          <Box
            component="span"
            data-testid="open-information-modal-link"
            onClick={() => setIsOpen(true)}>
            <Typography
              variant="body2"
              component="span"
              color="secondary"
              sx={{ cursor: "pointer" }}>
              Information Disclosure
            </Typography>
          </Box>{" "}
          and agree to our <LegalDocumentLink document="PrivacyPolicy" />,{" "}
          <LegalDocumentLink document="CloudServicesAgreement" /> and{" "}
          <LegalDocumentLink document="TcpaDisclosure" />.
        </Typography>
      </Box>
      <InformationModal open={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
